"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _classnames = _interopRequireDefault(require("classnames"));

require("./styles/_explore-more.scss");

function ExploreMore(a) {
  var b = a.title,
      c = a.subtitle,
      d = a.btnText,
      e = a.imageUrl,
      f = a.onClick,
      g = a.className;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("explore-more", g)
  }, _react["default"].createElement(_uiKit.Image, {
    width: "100%",
    height: "100%",
    backgroundSize: "cover",
    defaultImageIcon: "faq",
    imageUrl: e
  }), _react["default"].createElement("div", {
    className: "explore-more__content"
  }, _react["default"].createElement(_uiKit.Text, {
    darkTheme: !0,
    heading4: !0
  }, c), _react["default"].createElement(_uiKit.Text, {
    heading2: !0,
    darkTheme: !0
  }, b), _react["default"].createElement(_uiKit.Button, {
    onClick: f
  }, d)));
}

ExploreMore.defaultProps = {
  subtitle: "Need help?",
  btnText: "Explore More"
};

var _default = (0, _react.memo)(ExploreMore);

exports["default"] = _default;